module.exports = __webpack_public_path__ + "img/audio-list-loop.9d243c6f.png";